<template>
  <Card class="layout-card" style="height: 100%">
    <div
      v-if="mode === 'list'"
      style="height: 100%; display: flex; flex-direction: column"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          flex-shrink: 0;
        "
      >
        <div class="search-form">
          <Select
            style="width: 150px; margin-right: 10px"
            placeholder="功能点"
            v-model="searchForm.experimentCapability"
            filterable
            clearable
          >
            <Option
              v-for="(item, index) in capabilitieList"
              :key="index"
              :value="item.code"
              :label="item.desc? item.desc.trim():''"
            >
              {{ item.desc }}
            </Option>
          </Select>
          <Select
            style="width: 150px; margin-right: 10px"
            placeholder="和其他实验"
            v-model="searchForm.experimentType"
            filterable
            clearable
          >
            <Option :value="0">互斥</Option>
            <Option :value="1">并行</Option>
          </Select>
          <Select
            style="width: 150px; margin-right: 10px"
            placeholder="测试状态"
            v-model="searchForm.experimentStatus"
            filterable
            clearable
          >
            <Option :value="0">未开始</Option>
            <Option :value="1">进行中</Option>
            <Option :value="2">已结束</Option>
          </Select>
          <Select
            style="width: 150px; margin-right: 10px"
            placeholder="创建人"
            v-model="searchForm.createUser"
            filterable
            clearable
          >
            <Option
              v-for="(item, index) in userList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
          <Button type="primary" @click="getData()">搜索</Button>
        </div>
        <div>
          <Button type="primary" @click="handleAddExperiment">新增实验</Button>
        </div>
      </div>

      <div style="height: 100%; overflow: auto">
        <Table :data="tableData" :columns="columns" :loading="loading"></Table>
        <div style="margin-top: 10px; text-align: center">
          <Pages :page="page" :func="getData"></Pages>
        </div>
      </div>
    </div>

    <div v-else style="height: 100%">
      <AddExperiment
        :options="{ capabilitieList: capabilitieList }"
        ref="addRef"
        @back="
          mode = 'list'
          getData(page.current)
        "
        @submit="handleStepSubmit"
        :editData="editData"
        :mode="mode"
      />
    </div>
  </Card>
</template>

<script>
import {
  getAbTestCapabilities,
  getAbTestInfo,
  getAbTestList,
  getAbTestUser,
  startAbTest
} from '@/api/abtest'
import Pages from '@/components/pages'
import {
  appendCapabilityOption,
  buildExperimentEditorForm,
  extractDefaultGroupParam,
  getCapabilityDesc as resolveCapabilityDesc,
  normalizeCapabilityOptions
} from './helpers'
import AddExperiment from './components/AddExperiment.vue'

export default {
  components: {
    Pages,
    AddExperiment
  },
  data() {
    return {
      mode: 'list',
      editData: null,
      searchForm: {
        experimentCapability: '',
        experimentType: '',
        experimentStatus: 1,
        createUser: ''
      },
      capabilitieList: [],
      userList: [],
      tableData: [],
      columns: [
        { title: '实验ID', key: 'id' },
        { title: '实验名称', key: 'experimentName' },
        {
          title: '功能点',
          key: 'experimentCapabilityDesc',
          render: (h, params) => {
            return (
              <span>
                {params.row.experimentCapabilityDesc ||
                  this.getCapabilityDesc(params.row.experimentCapability)}
              </span>
            )
          }
        },
        { title: '和其他实验', key: 'experimentTypeDesc' },
        { title: '实验配置数量', key: 'groupCount' },
        { title: '样本人数', key: 'sampleCount' },
        { title: '实验状态', key: 'experimentStatusDesc' },
        { title: '创建人', key: 'createUserName' },
        { title: '开始日期', key: 'startTime' },
        {
          title: '操作',
          key: 'operation',
          width: 130,
          render: (h, params) => {
            return (
              <div>
                {params.row.experimentStatus === 2 ? (
                  <a
                    style="color:#5cadff;"
                    onClick={() => this.handleView(params.row)}
                  >
                    查看
                  </a>
                ) : (
                  <a
                    style="color:#2d8cf0;"
                    onClick={() => this.handleEdit(params.row)}
                  >
                    编辑
                  </a>
                )}
                {params.row.experimentStatus === 1 && (
                  <a
                    style="color:#5cadff;margin-left: 10px"
                    onClick={() => this.handleView(params.row)}
                  >
                    查看
                  </a>
                )}
                {!params.row.experimentStatus && (
                  <a
                    style="color:#2d8cf0;margin-left: 10px"
                    onClick={() => this.handleStart(params.row.id)}
                  >
                    开始实验
                  </a>
                )}
              </div>
            )
          }
        }
      ],
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  methods: {
    applyCapabilityOption(row = {}) {
      this.capabilitieList = appendCapabilityOption(
        this.capabilitieList,
        row.experimentCapability,
        row.experimentCapabilityDesc
      )
    },
    getCapabilityDesc(code) {
      return resolveCapabilityDesc(this.capabilitieList, code)
    },
    async getCapabilities() {
      try {
        const { data } = await getAbTestCapabilities()
        const capabilityList = Array.isArray(data) ? data : data.records || []
        this.capabilitieList = normalizeCapabilityOptions(capabilityList)
      } catch (error) {
        this.$Message.error('获取功能点失败')
      }
    },
    async ensureCapabilityOption(row = {}) {
      if (!this.capabilitieList.length) {
        await this.getCapabilities()
      }
      this.applyCapabilityOption(row)
    },
    getSeletions() {
      getAbTestUser().then((response) => {
        this.userList = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data.records)
          ? response.data.records
          : []
      })
    },
    handleStart(id) {
      startAbTest(id).then(() => {
        this.$Message.success('启动成功')
        this.getData(this.page.current)
      })
    },
    buildSearchParams() {
      return {
        current: this.page.current,
        size: this.page.size,
        experimentCapability:
          this.searchForm.experimentCapability !== ''
            ? this.searchForm.experimentCapability
            : undefined,
        experimentType:
          this.searchForm.experimentType !== ''
            ? this.searchForm.experimentType
            : undefined,
        experimentStatus:
          this.searchForm.experimentStatus !== ''
            ? this.searchForm.experimentStatus
            : undefined,
        createUser:
          this.searchForm.createUser !== ''
            ? this.searchForm.createUser
            : undefined
      }
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1

      this.loading = true
      getAbTestList(this.buildSearchParams())
        .then((response) => {
          this.tableData = response.data.records || []
          this.page.total = response.data.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAddExperiment() {
      this.mode = 'add'
      this.editData = null
    },
    openExperimentDetail(mode, detail) {
      const defaultGroupParam = extractDefaultGroupParam(detail)
      this.mode = mode
      this.$nextTick(() => {
        const formData = buildExperimentEditorForm(detail)
        this.$refs.addRef.form = formData
        this.$refs.addRef.currentStep = 2

        this.$nextTick(async () => {
          const step2Ref = this.$refs.addRef && this.$refs.addRef.$refs.step2Ref
          if (step2Ref && defaultGroupParam) {
            await step2Ref.applyDefaultGroup(defaultGroupParam)
          }

          if (mode === 'edit') {
            this.$refs.addRef.originForm = JSON.stringify(
              this.$refs.addRef.form
            )
          }
        })
      })
    },
    async handleEdit(row) {
      await this.ensureCapabilityOption(row)
      const { data } = await getAbTestInfo(row.id)
      this.applyCapabilityOption(data)
      this.openExperimentDetail('edit', data)
      this.editData = row
    },
    async handleView(row) {
      await this.ensureCapabilityOption(row)
      const { data } = await getAbTestInfo(row.id)
      this.applyCapabilityOption(data)
      this.openExperimentDetail('view', data)
      this.editData = row
    },
    handleStepSubmit() {
      this.mode = 'list'
      this.getData()
    }
  },
  mounted() {
    this.getCapabilities()
    this.getData()
    this.getSeletions()
  }
}
</script>

<style scoped lang="less">
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}

.search-form {
  display: flex;
  align-items: center;

  & > * {
    margin-right: 10px;
  }
}
</style>
